export default __webpack_public_path__ + "static/media/table.2302fc6d.svg";